
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: ['navLocalePath', 'navName'],
  emits: ['hide-navigation'],
  setup(props, { emit }) {
    const hideNavi = () => {
      emit('hide-navigation', '')
    }
    return { hideNavi }
  },
})
